import React from 'react';
import { format } from 'date-fns';
import { useNavigate } from 'react-router-dom';
import AppointmentStatusPill from './AppointmentStatusPill';
import OverviewBoardHeader from './board/OverviewBoardHeader';
import { ListRowSkeletonStack } from '../loading/skeletons';
import './styles/TodayAppointmentsCard.css';
import './board/OverviewBoard.css';

const TodayAppointmentsCard = ({ todayAppointments, loading = false, onViewAll, getServiceName, onAppointmentClick }) => {
  const navigate = useNavigate();

  const handleViewAll = () => {
    navigate('/app/overview/appointments', { state: { initialTab: 1 } });
  };

  const getServiceDisplay = (appointment) => {
    if (!appointment) return 'No service specified';

    const {
      service,
      serviceName
    } = appointment;

    return service?.name || serviceName || 'No service specified';
  };

  const renderAppointmentContent = (appointment) => {
    const when = new Date(appointment.dateTime);
    const timeLabel = Number.isNaN(when.getTime()) ? '—' : format(when, 'h:mm');
    const periodLabel = Number.isNaN(when.getTime()) ? '' : format(when, 'a');

    return (
      <>
        <div className="today-label-time">
          <span className="today-label-time__clock">{timeLabel}</span>
          {periodLabel ? <span className="today-label-time__period">{periodLabel}</span> : null}
        </div>
        <div className="today-label-body">
          <div className="today-label-body__top">
            <span className="today-label-name">{appointment.clientName || 'Client'}</span>
            <AppointmentStatusPill status={appointment.status} />
          </div>
          <span className="today-label-service">{getServiceDisplay(appointment)}</span>
        </div>
      </>
    );
  };

  const countLabel = loading
    ? 'Loading appointments'
    : `${todayAppointments.length} scheduled`;

  return (
    <div className="today-appointments-container overview-board">
      <OverviewBoardHeader
        eyebrow="Today"
        title="Appointments"
        count={countLabel}
        actionLabel="View"
        onAction={handleViewAll}
        actionTitle="View all today's appointments"
      />

      <div className="overview-board__body">
        {loading ? (
          <ListRowSkeletonStack rows={4} variant="compact" label="Loading today's appointments" />
        ) : todayAppointments.length > 0 ? (
          <ul className="today-label-table">
            {todayAppointments.slice(0, 4).map((appointment, index) => (
              <li key={appointment.id || index} className="today-label-table__item">
                <button
                  type="button"
                  className="today-label-row"
                  onClick={() => onAppointmentClick && onAppointmentClick(appointment)}
                >
                  {renderAppointmentContent(appointment)}
                </button>
              </li>
            ))}
          </ul>
        ) : (
          <div className="today-appointments-empty">
            <p>No appointments scheduled for today</p>
          </div>
        )}
      </div>

      {todayAppointments.length > 4 && (
        <button type="button" className="overview-board__more" onClick={handleViewAll}>
          {todayAppointments.length - 4} more today
        </button>
      )}
    </div>
  );
};

export default TodayAppointmentsCard;
